import loading from "./files/loading.json"

export const animations = {
  loading: loading,
}
